// Wrap the initialization code in a function
function initializeStickerAR() {
  if (!document.querySelector('[data-product-json]')) {
    console.warn('data-product-json element not found.');
    return;
  }

  const product_json = JSON.parse(document.querySelector('[data-product-json]').textContent);
  // if there's no media elements, we exit this function
  // if (!Array.isArray(product_json.media)) {
  //   return;
  // }
  const userAgent = navigator.userAgent;
  const xr = navigator.xr;
  var isAppleDevice = false;
  var isAndroidDevice = false;
  var supportsAR = false;
  if (userAgent.match(/iPhone/i) || userAgent.match(/iPad/i) || userAgent.match(/iPod/i)) {
    var isAppleDevice = true;
  } else if (userAgent.match(/Macintosh/i) && navigator.maxTouchPoints === 5) {
    var isAppleDevice = true;
  }
  if (userAgent.match(/Android/i)) {
    var isAndroidDevice = true;
  }
  if (isAppleDevice) {
    const a = document.createElement('a');
    if (a.relList.supports('ar')) {
      var supportsAR = true;
    } else {
      var supportsAR = false;
    }
  }
  if (isAndroidDevice) {
    if ('xr' in window.navigator) {
      var supportsAR = true;
    } else {
      var supportsAR = false;
    }
  }
  // Shopify AR
  function setupShopifyXr() {
    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', function () {
        setupShopifyXr();
      });
    } else {
      if (product_json !== null) {
        const productModels = product_json.media.filter((item) => item.media_type === 'model');
        window.ShopifyXR.addModels(productModels);
        window.ShopifyXR.setupXRElements();
      }
    }
  }
  window.Shopify.loadFeatures([
    {
      name: 'shopify-xr',
      version: '1.0',
      onLoad: setupShopifyXr,
    },
  ]);
  if (product_json !== null) {
    const variant_ar_id = product_json.media.find((item) => {
      return item.media_type == 'model';
    });

    const containerSticker3d = document.querySelector('.pdp-ar-container');
    const cssClasses = {
      activeThumbnail: 'active-thumbnail',
      hide: 'hide',
    };
    if (variant_ar_id) {
      containerSticker3d.setAttribute('data-shopify-title', variant_ar_id.alt);
      containerSticker3d.setAttribute('data-shopify-model3d-id', variant_ar_id.id);
      if (supportsAR) {
        containerSticker3d.classList.add(cssClasses.hide);
        containerSticker3d.classList.remove(cssClasses.hide);
      }
    } else {
      containerSticker3d.classList.add(cssClasses.hide);
      containerSticker3d.setAttribute('data-shopify-title', '');
      containerSticker3d.setAttribute('data-shopify-model3d-id', '');
    }
  }
}

// Call the function
initializeStickerAR();
